<section>
  <app-form-header></app-form-header>
  @if (form && hasRecipients) {
    <form class="send-tenant-mails-form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
          @if (senderAddress) {
            <app-postal-address
              [group]="form.controls['senderAddress']"
              [title]="'MAIL_FORM.SENDER_ADDRESS_HEADER'"
              [model]="senderAddress"
              [showName]="true"
              [mandatory]="true"
            ></app-postal-address>
          }
          @if (showRecipients) {
            <div class="astral-stack-s">
              <h4 class="send-tenant-mails-form__section-title">{{ 'MULTI_TENANT_FORM.RECIPIENT_HEADER' | translate }}</h4>
              <div class="send-tenant-mails-form__recipient-list astral-stack-s">
                @for (recipient of recipients; track recipient) {
                  <astral-layout-group
                    class="send-tenant-mails-form__recipient-row"
                    [columns]="2"
                    [tabletColumns]="1"
                    [mobileColumns]="1"
                    >
                    <astral-input
                      [label]="'ADDRESS_FORM.NAME_LABEL' | translate"
                      [value]="recipient.recipientName"
                      [readonly]="true"
                    ></astral-input>
                    <astral-input
                      [label]="'LEASE_AGREEMENT.LEASE_AGREEMENT_NUMBER_LABEL' | translate"
                      [value]="recipient.contractNumber"
                      [readonly]="true"
                    ></astral-input>
                  </astral-layout-group>
                }
              </div>
            </div>
          }
        </astral-layout-group>
      </section>
      <section class="astral-section-surface astral-form-stack">
        <astral-input [control]="form.controls['header']"></astral-input>
        <astral-textarea [control]="form.controls['body']" [rows]="16"></astral-textarea>
        <astral-input [control]="form.controls['footer']"></astral-input>
      </section>
      <div class="astral-form-actions">
        <astral-button type="submit" variant="primary" labelKey="SAVE_BTN" [disabled]="isSaveDisabled"></astral-button>
        <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
        <astral-button
          type="button"
          variant="secondary"
          labelKey="PREVIEW_BTN"
          [disabled]="isPreviewDisabled"
          (click)="preview()"
        ></astral-button>
        @if (showSend) {
          <astral-button
            type="button"
            variant="primary"
            labelKey="SEND_BTN"
            [disabled]="isSendDisabled"
            (click)="send()"
          ></astral-button>
        }
      </div>
    </form>
  }
</section>
